import React, { useEffect, useState } from "react";
import MultiSelect from "../../../components/miscellaneous/MultiSelect/MultiSelect";
import api from "../../../helpers/api";
import { $t } from "../../../helpers/translator";
import Style from "./Register.module.scss";
import { Autocomplete, useJsApiLoader } from '@react-google-maps/api';
import { useLocation, Link } from 'react-router-dom';
import qs from 'qs';
import InputWithValidation from "../../../components/miscellaneous/InputWithValidation/InputWithValidation";
import _ from "lodash";

const Register = (props) => {
    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyBjywQFrNLLJaQNzbW_U2xY5A2hkB6Aweg",
        libraries: ["places"]
        // ...otherOptions
    })
    const location = useLocation();
    // Define extra variables we need
    const {uId, email, name, picture} = qs.parse(location.search, { ignoreQueryPrefix: true });
    const googleLibs = ["places"];
    // Define States
    const [loading, setLoading] = useState(false);
    const [step, setStep] = useState(1);
    const [finishedSteps, setFinishedSteps] = useState([]);
    const [errors, setErrors] = useState([]);
    const [countries, setCountries] = useState([]);
    const [distributers, setDistributers] = useState([]);
    const [input, setInput] = useState({
        is_from_social: uId ? uId : false,
        distributor_code: null,
        distributor_country_id: null,
        org_name: '',
        org_phone: '',
        org_phone_prefix: null,
        org_address: {name: ''},
        org_address_text: null,
        user_name: name ? name : '',
        user_email: email ? email : '',
        user_password: '',
        user_picture: picture ? picture : '',
        tos_agree: false
    });
    const [result, setResult] = useState({
        success: null,
        errors: []
    });
    const [isChain, setIsChain] = useState(false);
    const [type, setType] = useState('clinic');
    const [placesInput, setPlacesInput] = useState(null);

    const [newPassword, setNewPassword] = useState({value: '', errors: []});
    const [newName, setNewName] = useState({value: '', errors: []});
    const [newEmail, setNewEmail] = useState({value: '', errors: []});
    const [formSent, setFormSent] = useState(false);

    // Define Steps
    const steps = [
        {
            menu: {
                label: $t('global.register.steps.ACCOUNT_TYPE.MENU.LABEL'),
                description: $t('global.register.steps.ACCOUNT_TYPE.MENU.DESCRIPTION')
            },
            content: () => {
                return (
                    <>
                        <h2 className={Style["content-title"]}>{$t('global.register.steps.ACCOUNT_TYPE.CONTENT.TITLE')}</h2>
                        <p className={Style["text-muted"]}>
                            {$t('global.register.steps.ACCOUNT_TYPE.CONTENT.DESCRIPTION')}
                        </p>

                        <div className={Style["d-flex"]}>
                            <div onClick={(e) => {
                                setType('clinic');
                                setIsChain(false);
                            }} className={type === 'clinic' ? [Style["account-type"], Style["account-type-active"]].join(' ') : Style['account-type']}>
                                <h3 className={Style["account-type-title"]}>{$t('global.register.steps.ACCOUNT_TYPE.CONTENT.CLINIC.TITLE')}</h3>
                                <p className={Style["account-type-description"]}>
                                {$t('global.register.steps.ACCOUNT_TYPE.CONTENT.CLINIC.DESCRIPTION')}
                                </p>
                            </div>
                            <div onClick={(e) => {
                                setType('chain');
                                setIsChain(true);
                            }} className={type === 'chain' ? [Style["account-type"], Style["account-type-active"]].join(' ') : Style['account-type']}>
                                <h3 className={Style["account-type-title"]}>{$t('global.register.steps.ACCOUNT_TYPE.CONTENT.CHAIN.TITLE')}</h3>
                                <p className={Style["account-type-description"]}>
                                    {$t('global.register.steps.ACCOUNT_TYPE.CONTENT.CHAIN.DESCRIPTION')}
                                </p>
                            </div>
                        </div>
                    </>
                )
            },
            verify: async() => {
                return true
            },
            isSuccess: false
        },
        {
            menu: {
                label: $t('global.register.steps.CONNECT.MENU.LABEL'),
                description: $t('global.register.steps.CONNECT.MENU.DESCRIPTION')
            },
            content: () => {
                return (
                    <>
                        <h2 className={Style["content-title"]}>{$t('global.register.steps.CONNECT.CONTENT.TITLE')} {type.charAt(0).toUpperCase() + type.slice(1)}</h2>
                        <p className={Style["text-muted"]}>
                            {$t('global.register.steps.CONNECT.CONTENT.DESCRIPTION')}
                        </p>
                        <form autocomplete="chrome-off" onSubmit={(e) => {e.preventDefault(); nextStep()}} className={[Style["form"], Style["form-line"]].join(' ') + ` w-100`}>
                            <div className={Style["form-group"]}>
                                <label>{$t('global.register.steps.CONNECT.CONTENT.FIELDS.COUNTRY.LABEL')}</label>
                                <MultiSelect
                                    searchable={true}
                                    placeholder={$t('global.register.steps.CONNECT.CONTENT.FIELDS.COUNTRY.DEFAULT_OPTION')}
                                    options={[{value: 0, label: $t('global.register.steps.CONNECT.CONTENT.FIELDS.COUNTRY.DEFAULT_OPTION')}].concat(countries.map((c) => {
                                        return {
                                            value: c.id,
                                            label: c.name
                                        }
                                    }))}
                                    selected={input.distributor_country_id}
                                    onValueChange={(data) => {
                                        loadDistributers(data)
                                    }}
                                />
                            </div>
                            {distributers.length > 0 && <div className={Style["form-group"]}>
                                <label>{$t('global.register.steps.CONNECT.CONTENT.FIELDS.CODE.LABEL')}</label>
                                <MultiSelect
                                    searchable={true}
                                    placeholder={$t('global.register.steps.CONNECT.CONTENT.FIELDS.CODE.DEFAULT_OPTION')}
                                    options={distributers.map((d) => {
                                        return {
                                            value: d.id,
                                            label: `${d.id} - ${d.name}`
                                        }
                                    })}
                                    selected={input.distributor_code}
                                    onValueChange={(data) => {
                                        // console.log(data);
                                        applyInputValue('distributor_code', data);
                                    }}
                                />
                            </div>}
                        </form>
                    </>
                )
            },
            verify: async() => {
                const stepErrors = [];
                const {distributor_country_id, distributor_code} = input;

                if(distributor_country_id !== null) {
                    if(distributor_country_id.value === null || distributor_country_id.value == 0) {
                        stepErrors.push({msg: $t('global.register.errors.MISSING_DISTRIBUTER_COUNTRY')})
                    }
                } else {
                    stepErrors.push({msg: $t('global.register.errors.MISSING_DISTRIBUTER_COUNTRY')})
                }

                if(distributor_code !== null) {
                    if(distributor_code.value === null || distributor_code.value == 0) {
                        stepErrors.push({msg: $t('global.register.errors.MISSING_DISTRIBUTER_CODE')})
                    }
                } else {
                    stepErrors.push({msg: $t('global.register.errors.MISSING_DISTRIBUTER_CODE')})
                }
                
                if(stepErrors.length > 0) return stepErrors
                
                const verify = await api.post('/onboarding/check/distributer', {
                    id: input.distributor_code.value,
                    country_id: input.distributor_country_id.value
                });

                return verify.data.data.is_valid ? true : [
                    {msg: $t('global.register.errors.UNKNOWN_DISTRIBUTER')}
                ];
            },
            isSuccess: false
        },
        {
            menu: {
                description: $t('global.register.steps.ORG_DETAILS.MENU.DESCRIPTION'),
                getLabel: () => {
                    return (`${type.charAt(0).toUpperCase() + type.slice(1)} ${$t('global.register.steps.ORG_DETAILS.MENU.DETAILS')}`)
                }
            },
            content: () => {
                return (
                        <div>
                            <h2 className={Style["content-title"]}>{$t('global.register.steps.ORG_DETAILS.CONTENT.TITLE')} {type.charAt(0).toUpperCase() + type.slice(1)}</h2>
                            <p className={Style["text-muted"]}>
                                {$t('global.register.steps.ORG_DETAILS.CONTENT.DESCRIPTION')}
                            </p>
                            <form onSubmit={(e) => {e.preventDefault(); nextStep()}} className={[Style["form"], Style["form-line"]].join(' ')}>
                                <div className={Style["form"]}>
                                    <div className={Style["form-group"]}>
                                        <label>{type.charAt(0).toUpperCase() + type.slice(1)} {$t('global.register.steps.ORG_DETAILS.CONTENT.FIELDS.NAME.LABEL')}</label>
                                        <input defaultValue={input.org_name} name="org_name" type="text" placeholder={$t('global.register.steps.ORG_DETAILS.CONTENT.FIELDS.NAME.PLACEHOLDER')} onChange={(e) => applyInput(e)} className={Style["form-control"]} required />
                                    </div>
                                    <div className={Style["form-group"]}>
                                        <label>{type.charAt(0).toUpperCase() + type.slice(1)} {$t('global.register.steps.ORG_DETAILS.CONTENT.FIELDS.PHONE.LABEL')}</label>
                                        <div className={Style['d-flex-absolute']}>
                                            <select name="org_phone_prefix" onChange={(e) => {applyInput(e)}} defaultValue={input.distributor_country_id ? input.distributor_country_id.value : null} className={[Style["form-control"], Style["form-control-prefix"]].join(' ')}>
                                                {countries.map((c) => {
                                                    return <option value={c.id}>{c.emoji}  +{c.phone_prefix}</option>
                                                })}
                                            </select>
                                            <input defaultValue={input.org_phone} name="org_phone" onChange={(e) => {applyInput(e)}} placeholder={$t('global.register.steps.ORG_DETAILS.CONTENT.FIELDS.PHONE.PLACEHOLDER')} type="phone" className={[Style["form-control"], Style["form-control-has-prefix"]].join(' ')} required />
                                        </div>
                                    </div>
                                </div>
                                <div className={Style["form"]}>
                                    <div className={Style["form-group"]}>
                                    <label>{type.charAt(0).toUpperCase() + type.slice(1)} {$t('global.register.steps.ORG_DETAILS.CONTENT.FIELDS.ADDRESS.LABEL')}</label>
                                    <Autocomplete
                                        onLoad={(autocomplete) => {
                                            setPlacesInput(autocomplete);
                                        }}
                                        onPlaceChanged={() => {
                                            const res = placesInput !== null ? placesInput.getPlace() : undefined;
                                            // console.log(res)
                                            if(res !== undefined) {
                                                const address = {
                                                    lat: res.geometry.location.lat(),
                                                    long: res.geometry.location.lng(),
                                                    name: res.formatted_address,
                                                    city: res.vicinity ? res.vicinity : null
                                                }

                                                setInput({...input, org_address: address});
                                                setErrors([]);
                                            }
                                        }}
                                    >
                                        
                                        <input defaultValue={input.org_address.name} placeholder={$t('global.register.steps.ORG_DETAILS.CONTENT.FIELDS.ADDRESS.PLACEHOLDER')} type="address" className={Style["form-control"]} required />
                                    </Autocomplete>
                                    </div>
                                </div>
                            </form>
                        </div>
                )
            },
            verify: async() => {
                const errors = [];
                const {org_name, org_phone, org_phone_prefix, org_address, org_address_text} = input;

                if(org_name === null || org_name.length < 1) {
                    errors.push({msg: $t('global.register.errors.MISSING_NAME')})
                }

                if(org_phone === null || org_phone.length < 1) {
                    errors.push({msg: $t('global.register.errors.MISSING_PHONE')})
                }

                if(org_phone_prefix === null) {
                    errors.push({msg: $t('global.register.errors.MISSING_PHONE')})
                }

                if(org_address.long === undefined) {
                    if(org_address_text !== undefined) {
                        errors.push({msg: $t('global.register.errors.MISSING_ADDRESS_DROPDOWN')})
                    } else {
                        errors.push({msg: $t('global.register.errors.MISSING_ADDRESS')})
                    }
                }

                return errors.length === 0 ? true : errors
            },
            isSuccess: false
        },
        {
            menu: {
                label: $t('global.register.steps.USER_DETAILS.MENU.LABEL'),
                description: $t('global.register.steps.USER_DETAILS.MENU.DESCRIPTION')
            },
            content: () => {
                return (
                    <>
                        <h2 className={Style["content-title"]}>{$t('global.register.steps.USER_DETAILS.CONTENT.TITLE')}</h2>
                        <p className={Style["text-muted"]}>
                            {$t('global.register.steps.USER_DETAILS.CONTENT.DESCRIPTION')}
                        </p>
                        <form autoComplete="new-password" role="combobox" spellcheck="false" onSubmit={(e) => {e.preventDefault(); nextStep()}}>
                            <div className={`${Style["form"]} ${Style["flexRow"]}`}>
                                <div className={Style["form-group"]}>
                                    <label>{$t('global.register.steps.USER_DETAILS.CONTENT.FIELDS.NAME.LABEL')}</label>
                                    {/*<input defaultValue={input.user_name} name='user_name_fake'  onChange={(e) => applyInput(e)} placeholder={$t('global.register.steps.USER_DETAILS.CONTENT.FIELDS.NAME.PLACEHOLDER')} className={Style["form-control"]} />*/}
                                    <InputWithValidation
                                        name="user_name"
                                        validations={['required', 'minLength(3)']}
                                        onChange={(data) => {
                                            setNewName(data)
                                            applyInput({
                                                target: {
                                                    name: 'user_name',
                                                    value: data.value
                                                }
                                            })
                                        }}
                                        touched={formSent}
                                        type="text"
                                        value={newName.value}
                                        placeholder={$t('global.register.steps.USER_DETAILS.CONTENT.FIELDS.NAME.PLACEHOLDER')}
                                    />

                                </div>
                                <div className={Style["form-group"]}>
                                    <label>{$t('global.register.steps.USER_DETAILS.CONTENT.FIELDS.EMAIL.LABEL')}</label>
                                    {/*<input defaultValue={input.user_email} name="user_email_fake" autoComplete="new-password" onChange={(e) => applyInput(e)} type="email" placeholder={$t('global.register.steps.USER_DETAILS.CONTENT.FIELDS.EMAIL.PLACEHOLDER')} className={Style["form-control"]} />*/}
                                    <InputWithValidation
                                        name="user_email_fake"
                                        validations={['required', 'email']}
                                        onChange={(data) => {
                                            setNewEmail(data)
                                            applyInput({
                                                target: {
                                                    name: 'user_email_fake',
                                                    value: data.value
                                                }
                                            })
                                        }}
                                        touched={formSent}
                                        type="email"
                                        value={newEmail.value}
                                        placeholder={$t('global.register.steps.USER_DETAILS.CONTENT.FIELDS.EMAIL.PLACEHOLDER')}className={Style["form-control"]}
                                    />

                                </div>
                                <div className={Style["form-group"]}>
                                    <label>{$t('global.register.steps.USER_DETAILS.CONTENT.FIELDS.PASSWORD.LABEL')}</label>
                                    {/*<input defaultValue={input.user_password} name="user_password_fake" autoComplete="new-password" onChange={(e) => applyInput(e)} type="password" placeholder={$t('global.register.steps.USER_DETAILS.CONTENT.FIELDS.PASSWORD.PLACEHOLDER')} className={Style["form-control"]} />*/}
                                    <InputWithValidation
                                        name="user_password_fake"
                                        validations={['required', 'password']}
                                        onChange={(data) => {
                                            setNewPassword(data)
                                            applyInput({
                                                target: {
                                                    name: 'user_password_fake',
                                                    value: data.value
                                                }
                                            })
                                        }}
                                        touched={formSent}
                                        type="password"
                                        value={newPassword.value}
                                        placeholder={$t('global.register.steps.USER_DETAILS.CONTENT.FIELDS.PASSWORD.PLACEHOLDER')}
                                        className={Style["form-control"]}
                                    />
                                </div>
                            </div>
                            <div className={Style["form"]}>
                                <div className={Style["form-group"]}>
                                    <input id="agreeBox" type="checkbox" name="tos_agree" onChange={(e) => applyInput(e)} />
                                    <label style={{marginLeft: '10px'}} htmlFor="agreeBox">
                                         {$t('global.register.steps.USER_DETAILS.CONTENT.FIELDS.TOS.AGREE')} 
                                         <a href="/#/content/terms" target="_blank"> {$t('global.register.steps.USER_DETAILS.CONTENT.FIELDS.TOS.TERMS')} </a> & 
                                         <a href="/#/content/privacy" target="_blank"> {$t('global.register.steps.USER_DETAILS.CONTENT.FIELDS.TOS.PRIVACY')} </a>
                                    </label>
                                </div>
                            </div>
                            
                        </form>
                    </>
                )
            },
            verify: async() => {
                setFormSent(true);
                const errors = [];
                const {user_name, user_email, user_password, tos_agree} = input;

                // if(user_name === null || user_name.length < 1) {
                //     errors.push({msg: $t('global.register.errors.MISSING_FULLNAME')})
                // }
                //
                // if(user_email === null || user_email.length < 1) {
                //     errors.push({msg: $t('global.register.errors.MISSING_EMAIL')})
                // }

                _.forEach(newName.errors, (v, k) => {
                    errors.push({msg: 'Name: '+v})
                })
                _.forEach(newEmail.errors, (v, k) => {
                    errors.push({msg: 'Email: '+v})
                })
                _.forEach(newPassword.errors, (v, k) => {
                    errors.push({msg: 'Password: '+v})
                })
                // if(user_password === null || user_password.length < 1) {
                //     errors.push({msg: $t('global.register.errors.MISSING_PASSWORD')})
                // } else {
                //     if(user_password.length < 6) {
                //         errors.push({msg: $t('global.register.errors.WRONG_PASSWORD_LENGTH')})
                //     }
                // }

                if(tos_agree !== true) {
                    errors.push({msg: $t('global.register.errors.MISSING_AGREE')})
                }

                if(errors.length === 0) {
                    const verify = await api.post('/onboarding/check/email', {
                        type: 'user',
                        email: user_email
                    });
                    
                    if(verify.data.data.does_exist !== false) {
                        errors.push({msg: $t('global.register.errors.EMAIL_TAKEN')})
                    }
                }

                return errors.length === 0 ? true : errors
            },
            isSuccess: false
        }
    ]

    // Define Functions
    const applyInput = (e) => {
        // console.log(e)
        const name = e.target.name.split('_fake')[0];
        let value = e.target.value;

        if(e.target.type === 'checkbox') {
            value = e.target.checked;
        }

        const newInput = {...input}
        newInput[name] = value;
        
        setInput(newInput);
        setErrors([]);
    }

    const applyInputValue = (name, value) => {
        const newInput = {...input}
        newInput[name] = value;
        setInput(newInput);
        setErrors([]);
    }

    const loadCountries = async() => {
        const getCountries = await api.get('/onboarding/countries');
        return getCountries.data.data;
    }

    const loadDistributers = async(selectionData) => {
        const countryId = selectionData.value;
        const newInput = {...input};
        newInput.distributor_country_id = selectionData;
        newInput.distributor_code = null;
        newInput.org_phone_prefix = countryId;

        setInput(newInput);
        setLoading(true);

        const get = await api.get(`/onboarding/distributer/${countryId}`);
        const {data} = get.data;

        setDistributers(data);
        setLoading(false);
    }

    const getErrors = () => {
        return (
            <>
                {errors.map((e) => {
                    return (<div className='error' style={{color: 'red', marginTop: '10px'}}>
                        <span style={{fontWeight: 'bold', fontSize: '20px', marginRight: '10px'}}>!</span>{e.msg}
                    </div>)
                })}
            </>
        )
    }

    const nextStep = () => {
        const originalStep = step;
        const newFinishedSteps = finishedSteps;
        const originalStepObj = steps[originalStep - 1];
        const totalSteps = steps.length;

        setLoading(true);

        originalStepObj.verify().then((isVerified) => {
            if(isVerified === true) {
                newFinishedSteps.push(originalStep)
                sleep(1000).then(() => {
                    if(totalSteps >= (step + 1)) {
                        setStep(step + 1);
                        setFinishedSteps(newFinishedSteps);
                        setLoading(false);
                    } else {
                        createAccount().then((res) => {
                            setFinishedSteps(newFinishedSteps);
                            setLoading(false);
                            setResult({
                                success: res.data.success,
                                errors: res.data.errors
                            });
                        })
                    }
                })
            } else {
                setLoading(false);
                setErrors(isVerified);
            }
        });
    }

    const previousStep = () => {
        const newStep = step - 1;
        const newFinishedSteps = finishedSteps;
        const index = finishedSteps.indexOf(newStep);

        if(index > -1) {
            newFinishedSteps.splice(index, 1)
        }

        setStep(newStep);
        setFinishedSteps(newFinishedSteps);
        setErrors([]);
    }

    const isLastStep = () => {
        return step === steps.length;
    }

    const createAccount = () => {
        const formInput = {...input};
        formInput.distributor_code = formInput.distributor_code.value;
        formInput.distributor_country_id = formInput.distributor_country_id.value;
        formInput.org_phone_prefix = countries.filter((c) => c.id == formInput.org_phone_prefix)[0].phone_prefix;
        return api.post('/onboarding/register', {
            ...formInput,
            is_chain: isChain
        })
    }

    const resetResult = () => {
        let newFinishedSteps = [...finishedSteps];
        newFinishedSteps.pop();

        setStep(step);
        setFinishedSteps(newFinishedSteps);
        setLoading(false);
        setResult({
            success: null,
            errors: []
        });
    }

    const sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    useEffect(() => {
        // Get Countries
        loadCountries().then(countries => {
            setCountries(countries);
        });
    }, []);

    const currentStepIndex = step - 1;
    const currentStep = steps[currentStepIndex];

return (
    <div className={Style['pageContainer']}>
        <div className={Style['container']}>
            <div className={result.success === true ? [Style["step-result"], Style["step-result-show"]].join(' ') : Style["step-result"]}>
                <div className={Style['step-result-container']}>
                    <span className={[Style["step-result-icon"], Style["step-result-icon-success"]].join(' ')}>✓</span>
                    <h2 className={Style['step-result-title']}>{$t('global.register.results.SUCCESS.TITLE')}</h2>
                    <p className={Style['text-muted']}>{$t('global.register.results.SUCCESS.DESCRIPTION.PART_ONE')} <b>{input.user_email}</b>. {$t('global.register.results.SUCCESS.DESCRIPTION.PART_TWO')}</p>
                    <p style={{textAlign: 'center'}}>
                        <Link to="/login" className={Style['btn']}>Go to Login</Link>
                    </p>
                    <br />
                    <b>{$t('global.register.results.SUCCESS.CHECK_MOBILE')}</b>
                    <div className={Style['d-flex']}>
                        <a href="https://play.google.com/store/apps/details?id=io.gonative.android.alpbmr&hl=en&gl=US" target="_blank"><img width={160} src='assets/googleplay.svg' /></a>
                        <a href="https://apps.apple.com/ph/app/alma-smart-clinic/id1581397522" target="_blank"><img width={160} src='assets/appstore.svg' /></a>
                    </div>
                </div>
            </div>
            <div className={result.success === false ? [Style["step-result"], Style["step-result-show"]].join(' ') : Style["step-result"]}>
            <span className={[Style["step-result-icon"], Style["step-result-icon-error"]].join(' ')}>×</span>
                <h2 className={Style['step-result-title']}>{$t('global.register.results.ERROR.TITLE')}</h2>
                {result.errors.map((err) => {
                    return (<div style={{color: 'red', fontSize: '20px'}}><span style={{fontWeight: 'bold', marginRight: '5px'}}>!</span> 
                        {err.error_code !== undefined ? ($t(`global.register.errors.${err.error_code}`) !== err.error_code ? $t(`global.register.errors.${err.error_code}`) : err.error) : err.error}
                    </div>)
                })}
                <button onClick={(e) => {resetResult()}} className={[Style['btn'], Style['btn-primary']].join(' ')} style={{marginTop: '20px'}}>{$t('global.register.results.ERROR.TRYAGAIN')}</button>
                <p style={{textAlign: 'center'}}>
                    <Link to="/login" className={Style['link']}>Go to Login</Link>
                </p>
            </div>
            <div className={Style['wizard-header']}>
                <h1 className={Style['title']}>SmartClinic {$t('global.register.title')}</h1>
                <div className={Style['login-box']}>{$t('global.register.hasAccount')} <Link to="/login" className={Style['link']}>{$t('global.register.loginHere')}</Link></div>
            </div>

            <div className={Style["wizard"]}>
                <div className={Style["wizard-menu"]}>
                    {steps.map((s, i) => {
                        const stepNum = i + 1;
                        const menuItemClass = [Style['step-menu-item']];
                        const isActive = step === stepNum;
                        const isFinished = finishedSteps.includes(stepNum);
                        if(isActive) {
                            menuItemClass.push(Style["step-menu-item-active"]);
                        }

                        if(isFinished) {
                            menuItemClass.push(Style["step-menu-item-completed"]);
                        }

                        return (
                            <div className={menuItemClass.join(' ')}>
                                {isFinished === false ? step == stepNum && errors.length > 0 ? <span className={[Style["step-indicator"], Style["step-indicator-failed"]].join(' ')}>×</span> : <span className={Style["step-indicator"]}>{stepNum}</span> : <span className={[Style["step-indicator"], Style["step-indicator-completed"]].join(' ')}>✓</span> }
                                
                                <div className={Style["step-menu-item-details"]}>
                                    <h3 className={Style["step-menu-item-title"]}>{s.menu.getLabel === undefined ? s.menu.label : s.menu.getLabel()}</h3>
                                    <p className={Style['step-menu-item-description']}>
                                    {s.menu.description}
                                    </p>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className={Style["wizard-content"]}>
                    <div className={loading ? [Style["step-loader"], Style["step-loader-show"]].join(' ') : Style["step-loader"]}>
                        <svg version="1.1" id="loader-1" x="0px" y="0px"
                        width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" >
                            <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                                s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                                c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
                                <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                                    C22.32,8.481,24.301,9.057,26.013,10.047z">
                                    <animateTransform attributeType="xml"
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 20 20"
                                    to="360 20 20"
                                    dur="0.5s"
                                    repeatCount="indefinite"/>
                                </path>
                        </svg>
                    </div>
                    <div className={Style["step-content"]}>{currentStep.content()} {getErrors()}</div>

                    <div className={Style["wizard-footer"]}>
                        {step !== 1 && <button onClick={(e) => {previousStep()}} className={[Style['btn'], Style['btn-secondary']].join(' ')}>{$t('global.register.buttons.PREVIOUS')}</button>}
                        <button disabled={errors.length > 0 ? true : false} onClick={(e) => {nextStep()}} className={[Style['btn'], Style['btn-primary']].join(' ')}>
                            {!isLastStep() ? $t('global.register.buttons.CONTINUE') : $t('global.register.buttons.COMPLETE')}
                        </button>
                    </div>
                </div>
            </div>
            <div className={Style.terms}>
                <a href="/#/content/terms" target="_blank" rel="noreferrer">Terms of Service</a>
                <span>•</span>
                <a href="/#/content/privacy" target="_blank" rel="noreferrer">Privacy Policy</a>
            </div>
        </div>
    </div>)
};

export default Register;